// "Count me in" one-tap join for visitors who arrive from a Postscript SMS (anh 11-02). Postscript adds `s-id` (= the subscriber's
// ps_id, verified 11-02) to SMS links, so these visitors are already SMS subscribers: one tap → Apps Script webhook
// (bs26-b26-onetap-join-postscript-tag-apps-script/) adds the tag `b26-onetap` (in the "Biggest Sale 2026" segment) → "✓ You're on the list".
// Email visitors (11-02): Klaviyo adds `_kx` to every email link. On load the page asks the endpoint (dry) whether that profile's
// phone is an ACTIVE Postscript SMS subscriber; only then the same one-tap shows (58–85% of email visitors on 11-02). Email-only
// people keep the normal TEXT B26 / phone form — never added to SMS without their own opt-in.
// No Messages app, no new consent (they already get our texts). If the call fails, the page opens Messages with B26 typed
// (the normal path), so nobody gets stuck. Never on REG or without s-id. Loads before the ask card + hero scripts.
(function () {
  const ENDPOINT = 'https://script.google.com/macros/s/AKfycbzVp2-_WObmVKv3pyC7bmM4pdIJYnztFHstxyG_zPRZRKvglSopX3zeBWqqbQHsURWb/exec';
  const C = window.SLQ_CONFIG, T = window.SLQ_TRACK || { listAction() {} };
  const S = () => window.SLQ_STATE;
  const qs = new URLSearchParams(location.search);
  const sid = (qs.get('s-id') || '').trim(), kx = (qs.get('_kx') || '').trim();
  const isReg = !!(window.SLQ_PAGE && window.SLQ_PAGE.reg) || qs.get('seg') === 'reg';
  // Kill switch: ENABLED flips to true once the Apps Script web app is authorized + dry-run passes. ?onetap=1 = live preview.
  const ENABLED = true; // ON 11-02 ~04:20 ET: web app authorized, dry-run ×3 + browser CORS PASS
  const ENABLED_EMAIL = true; // email (_kx) one-tap kill switch
  const viaSid = /^\d{5,12}$/.test(sid), viaKx = !viaSid && /^[A-Za-z0-9_.\-]{8,300}$/.test(kx);
  const id = () => (viaSid ? { sid } : { kx }); // who is joining: SMS link s-id, else email _kx
  const on = (ENABLED || qs.has('onetap')) && viaSid && !isReg; // email: switched on after the dry check below
  const store = { get(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (_) {} } };
  const sms = `sms:${C.sms.number}?&body=${C.sms.keyword}`;
  let busy = false;

  const joinedNote = () => `We’ll text you the sale link <span class="slq-nowrap">(${C.sale.open})</span>.`;
  // Forwarded SMS links carry the ORIGINAL recipient's s-id (11-02 review). If that subscriber is already on the list
  // (tag biggest-sale-2026 from B26 / tag sync / an earlier one-tap — the endpoint answers already:true), the person holding
  // the phone may be someone else: say so and give them the real way in. Never stored, so a revisit asks again.
  const notYou = (where) => `<a class="lp-linkbtn" data-b26 data-hc-el="onetap-notyou-${where}" href="${sms}">Not you? Text ${C.sms.keyword} to join.</a>`;
  const doneHtml = (where) => (S().onetapAlready ? `<span>✓ You’re already on the list.</span> ${notYou(where)}` : `<span>✓ You’re on the list. ${joinedNote()}</span>`);
  // Card body used by the shared ask card (quiz result / All designs / page end) for these visitors.
  function cardBody(where) {
    if (S().onetapJoined) return doneHtml(where);
    return `<span>You already get our texts. Tap once to get the sale link <span class="slq-nowrap">(${C.sale.open})</span>.</span>
      <button class="slq-btn" data-onetap="${where}" data-hc-el="onetap-join-${where}">COUNT ME IN</button>
      <a class="lp-linkbtn" data-b26 data-hc-el="onetap-text-instead-${where}" href="${sms}">Not you? Text ${C.sms.keyword}</a>`;
  }

  // Hero card: COUNT ME IN first; TEXT B26 becomes a small "Or text B26" link; the phone form is not needed (already subscribers).
  function setupHero() {
    const join = document.querySelector('[data-lp-join]'); if (!join) return;
    const why = join.querySelector('.lp-why'); const heroSms = join.querySelector('[data-b26]');
    if (S().onetapJoined) {
      join.querySelectorAll('.lp-why, [data-b26], [data-lp-sent-note], [data-lp-showphone], [data-lp-phone], .lp-already').forEach((el) => { el.hidden = true; el.style.display = 'none'; });
      let done = join.querySelector('[data-onetap-done]');
      if (!done) { done = document.createElement('div'); done.setAttribute('data-onetap-done', ''); join.prepend(done); }
      done.innerHTML = S().onetapAlready ? `<p class="lp-card__h">✓ You’re already on the list</p><p class="slq-fine">${notYou('hero')}</p>`
        : `<p class="lp-card__h">✓ You’re on the list</p><p class="slq-fine">${joinedNote()}</p>`;
      return;
    }
    if (why) why.textContent = `You already get our texts. Tap once and we’ll text you the sale link (${C.sale.open}).`;
    if (heroSms && !join.querySelector('[data-onetap="hero"]')) {
      const b = document.createElement('button'); b.className = 'slq-btn'; b.textContent = 'COUNT ME IN';
      b.setAttribute('data-onetap', 'hero'); b.setAttribute('data-hc-el', 'onetap-join-hero');
      heroSms.before(b);
      heroSms.className = 'lp-linkbtn'; heroSms.textContent = `Not you? Text ${C.sms.keyword}`; heroSms.setAttribute('data-hc-el', 'onetap-text-instead-hero');
      join.querySelectorAll('[data-lp-sent-note], [data-lp-showphone], [data-lp-phone]').forEach((el) => { el.style.display = 'none'; });
    }
  }

  function refreshAll() {
    setupHero();
    if (window.SLQ_RESULT && document.querySelector('#slq .slq-res')) window.SLQ_RESULT.render(null, true); // only when a list is shown
    if (window.SLQ_BROWSE) window.SLQ_BROWSE.render();
    if (window.SLQ_ASK && window.SLQ_ASK.renderEnd) window.SLQ_ASK.renderEnd();
    if (window.SLQ_STICKY) window.SLQ_STICKY.update();
    if (window.SLQ_ZOOM) window.SLQ_ZOOM.refresh(); // photo zoom's join area
  }

  async function join(where) {
    if (busy || S().onetapJoined) return;
    busy = true; T.listAction('onetap-tap', where);
    document.querySelectorAll('[data-onetap]').forEach((b) => { b.disabled = true; b.textContent = 'Adding you…'; });
    let ok = false, already = false;
    try {
      const ctl = new AbortController(); const t = setTimeout(() => ctl.abort(), 9000);
      const res = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ brand: String(C.brand || '').toLowerCase(), ...id() }), signal: ctl.signal });
      clearTimeout(t); const j = await res.json(); ok = !!(j && j.ok); already = !!(j && j.already);
    } catch (_) { ok = false; }
    busy = false;
    if (ok) {
      const st = S(); st.onetapJoined = true; st.onetapAlready = already; st.textedB26 = true;
      if (!already) { store.set('slq-onetap', '1'); try { sessionStorage.setItem('slq-texted', '1'); } catch (_) {} } // already = maybe not this person: remember nothing
      T.listAction(already ? 'onetap-already' : 'onetap-joined', where); refreshAll();
    } else {
      T.listAction('onetap-fail', where); // fall back to the normal path: Messages with B26 typed
      document.querySelectorAll('[data-onetap]').forEach((b) => { b.disabled = false; b.textContent = 'COUNT ME IN'; });
      location.href = sms;
    }
  }

  document.addEventListener('click', (e) => { const b = e.target.closest('[data-onetap]'); if (b) { e.preventDefault(); join(b.dataset.onetap); } });

  window.SLQ_ONETAP = { on, cardBody, join, doneHtml }; // .on is read live by the ask card, sticky and zoom
  // Email visitor: one quiet dry check; nothing changes on the page unless the endpoint confirms an active SMS subscriber.
  if (ENABLED_EMAIL && viaKx && !isReg) document.addEventListener('DOMContentLoaded', async () => {
    try {
      const ctl = new AbortController(); const t = setTimeout(() => ctl.abort(), 6000);
      const res = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ brand: String(C.brand || '').toLowerCase(), kx, dry: true }), signal: ctl.signal });
      clearTimeout(t); const j = await res.json(); if (!(j && j.ok)) return;
      window.SLQ_ONETAP.on = true;
      if (store.get('slq-onetap') === '1') { S().onetapJoined = true; S().textedB26 = true; }
      else if (j.already) { const st = S(); st.onetapJoined = true; st.onetapAlready = true; st.textedB26 = true; } // already on the list: say so, no tap
      T.listAction('onetap-shown', j.already ? 'email-already' : 'email'); refreshAll();
    } catch (_) { /* no answer → the normal page stays */ }
  });
  // Init after every deferred script ran (SLQ_STATE comes from the steps script, which loads later).
  if (on) document.addEventListener('DOMContentLoaded', () => {
    if (store.get('slq-onetap') === '1') { S().onetapJoined = true; S().textedB26 = true; }
    T.listAction('onetap-shown', 'page'); refreshAll();
  });
})();
